module.exports = __webpack_public_path__ + "img/select-arrow.5bb568db.svg";